import React, {useState} from "react";
import Switch from "../../connectui/component/input/Switch";

const SwitchExample = () => {
  const [isOn, setIsOn] = useState(false);

  const handleToggle = (newState) => {
    setIsOn(newState);
    console.log("Switch is now:", newState ? "ON" : "OFF");
  };

  return (
    <div>
      <h3>Switch Component Example</h3>
      <Switch isChecked={isOn} onChange={handleToggle} />
      <p>The switch is currently: {isOn ? "ON" : "OFF"}</p>
    </div>
  );
};

export default SwitchExample;
